<template>
  <div class="d-flex flex-column">
    <label class="body2 color-secondary-600 bold mb-2">{{value.courseName}}</label>
    <div class="">
      <label class="body2 color-trabalho">{{value.whereFromCourse}}</label>
      <span class="ellipse-separator-blue" v-if="value.courseType"></span>
      <label class="body2 color-trabalho" v-if="value.courseType">{{value.courseType.nome}}</label>
    </div>
    <label class="caption1 color-gray-300 mb-2" v-if="value.dateFinished"
      >Concluído em {{formatedDate}}</label>
    <p class="caption1 color-gray-400">
      {{value.about}}
    </p>
    <div class="">
      <img
        class="float-right mt-2px-negative hover-pointer"
        src="/static/novomundosenai/imgs/icone-editar.svg"
        @click="btnEdit"
      />
        
      <img
        class="float-right mr-4 hover-pointer"
        src="/static/novomundosenai/imgs/icone-lixeira.svg"
        @click="btnRemove"
      />
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br'

export default {
  name: "FormationItem",
  props: ['value'],
  methods: {
    btnRemove() {
      this.$emit('remove');
    },
    btnEdit() {
      this.$emit('edit');
    }
  },
  computed: {
    formatedDate() {
      let date = dayjs(this.value.dateFinished, 'MMMM Do YYYY, h:mm:ss a');
      return date.locale('pt-br').format('MM/YYYY') 
    }
  }
};
</script>

<style scoped>
</style>
